import { Navigate, useLocation } from 'react-router-dom';

/**
 * Legacy QR callback route.
 *
 * 富工作 keeps redirecting to /wechatauth. The unified login page lives at
 * /login, so forward the callback query there and let that page exchange it.
 */
const WechatAuth = () => {
  const location = useLocation();
  return <Navigate to={`/login${location.search}${location.hash}`} replace />;
};

export default WechatAuth;
